import { useRouter } from 'next/router'
import {
  TopicsContainer,
  TopicContainer,
  TopicHeader,
  TopicElement,
} from '@styled_components/helpCentre/styled.components'
import { useTranslation } from 'react-i18next'

type Category = 'student' | 'author' | 'referralPartner' | 'legal'

interface TopicsProps {
  category: Category
}

const Topics = ({ category }: TopicsProps) => {
  const { t } = useTranslation('helpCentre')
  const router = useRouter()

  return (
    <div>
      {category == 'student' && (
        <TopicsContainer>
          <TopicContainer>
            <TopicHeader>{t('searchingAndPurchasing')}</TopicHeader>
            <TopicElement>{t('searchCourses')}</TopicElement>
            <TopicElement>{t('searchSubscriptions')}</TopicElement>
            <TopicElement>{t('giftCourse')}</TopicElement>
            <TopicElement>{t('giftCertificate')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('yourCourses')}</TopicHeader>
            <TopicElement>{t('studyCourses')}</TopicElement>
            <TopicElement>{t('courseCertificate')}</TopicElement>
            <TopicElement>{t('communicateWithInstructor')}</TopicElement>
            <TopicElement>{t('giftCertificate')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('paymentsPricingAndRefunds')}</TopicHeader>
            <TopicElement>{t('searchCourses')}</TopicElement>
            <TopicElement>{t('searchSubscriptions')}</TopicElement>
            <TopicElement>{t('giftCourse')}</TopicElement>
            <TopicElement>{t('giftCertificate')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('yourAccount')}</TopicHeader>
            <TopicElement>{t('searchCourses')}</TopicElement>
            <TopicElement>{t('searchSubscriptions')}</TopicElement>
            <TopicElement>{t('giftCourse')}</TopicElement>
            <TopicElement>{t('giftCertificate')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('safetyandAccessibility')}</TopicHeader>
            <TopicElement>{t('studyCourses')}</TopicElement>
            <TopicElement>{t('courseCertificate')}</TopicElement>
            <TopicElement>{t('communicateWithInstructor')}</TopicElement>
            <TopicElement>{t('giftCertificate')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('aboutEdugram')}</TopicHeader>
            <TopicElement>{t('searchCourses')}</TopicElement>
            <TopicElement>{t('searchSubscriptions')}</TopicElement>
            <TopicElement>{t('giftCourse')}</TopicElement>
            <TopicElement>{t('giftCertificate')}</TopicElement>
          </TopicContainer>
        </TopicsContainer>
      )}
      {category == 'author' && (
        <TopicsContainer>
          <TopicContainer>
            <TopicHeader>{t('courseCreation')}</TopicHeader>
            <TopicElement>{t('designingEngagingCurriculum')}</TopicElement>
            <TopicElement>{t('multiMediaIntegration')}</TopicElement>
            <TopicElement
              onClick={() => {
                router.push({
                  pathname: '/help-centre/author/optimize-video-for-edugram',
                })
              }}
            >
              {t('optimizeVideoForEdugram')}
            </TopicElement>
            <TopicElement>{t('bestPracticesForOnlineLearning')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('marketingYourCourse')}</TopicHeader>
            <TopicElement>{t('craftingCompellingDescriptions')}</TopicElement>
            <TopicElement>{t('utilizingSocialMedia')}</TopicElement>
            <TopicElement>{t('buildingAPersonalBrand')}</TopicElement>
            <TopicElement>{t('promotionalStrategies')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('managingStudentInteraction')}</TopicHeader>
            <TopicElement>{t('discussionForums')}</TopicElement>
            <TopicElement>{t('q&ASessions')}</TopicElement>
            <TopicElement>{t('providingFeedback')}</TopicElement>
            <TopicElement>{t('handlingDifficultStudents')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('financialAspects')}</TopicHeader>
            <TopicElement>{t('settingCoursePricesPublishing')}</TopicElement>
            <TopicElement>{t('revenueSharingModels')}</TopicElement>
            <TopicElement>{t('paymentProcessing')}</TopicElement>
            <TopicElement>{t('taxImplicationsForAuthors')}</TopicElement>
          </TopicContainer>
        </TopicsContainer>
      )}
      {category == 'referralPartner' && (
        <TopicsContainer>
          <TopicContainer>
            <TopicHeader>{t('collaboratingWithOtherInstructors')}</TopicHeader>
            <TopicElement>{t('crossPromotionOpportunities')}</TopicElement>
            <TopicElement>{t('jointCourses')}</TopicElement>
            <TopicElement>{t('collaborativeEvents')}</TopicElement>
            <TopicElement>{t('sharingResources')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('referralPrograms')}</TopicHeader>
            <TopicElement>{t('creatingIncentives')}</TopicElement>
            <TopicElement>{t('trackingReferrals')}</TopicElement>
            <TopicElement>{t('referralLinksandPromoCodes')}</TopicElement>
            <TopicElement>{t('maximizingReferralPotential')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('networkingInTheEducationIndustry')}</TopicHeader>
            <TopicElement>{t('joiningProfessionalGroups')}</TopicElement>
            <TopicElement>{t('attendingConferences')}</TopicElement>
            <TopicElement>{t('collaborativeWebinars')}</TopicElement>
            <TopicElement>
              {t('connectingWithEducationalInfluencers')}
            </TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('supportAndResourcesForPartners')}</TopicHeader>
            <TopicElement>{t('partnerHelpCenter')}</TopicElement>
            <TopicElement>{t('marketingMaterials')}</TopicElement>
            <TopicElement>{t('partnerSuccessStories')}</TopicElement>
            <TopicElement>{t('feedbackAndImprovement')}</TopicElement>
          </TopicContainer>
        </TopicsContainer>
      )}
      {category == 'legal' && (
        <TopicsContainer>
          <TopicContainer>
            <TopicHeader>{t('contentOwnershipAndUsageRights')}</TopicHeader>
            <TopicElement>{t('intellectualPropertyAgreements')}</TopicElement>
            <TopicElement>{t('licensingContent')}</TopicElement>
            <TopicElement>{t('fairUseGuidelines')}</TopicElement>
            <TopicElement>{t('avoidingPlagiarismIssues')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('termsOfServiceAndContracts')}</TopicHeader>
            <TopicElement>{t('draftingClearTermsofService')}</TopicElement>
            <TopicElement>{t('agreementTemplates')}</TopicElement>
            <TopicElement>{t('termsForStudentRefunds')}</TopicElement>
            <TopicElement>{t('clarifyingCourseAccessDuration')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>{t('privacyAndDataProtection')}</TopicHeader>
            <TopicElement>{t('studentDataHandling')}</TopicElement>
            <TopicElement>{t('gdprCompliance')}</TopicElement>
            <TopicElement
              onClick={() => {
                router.push({ pathname: '/help-centre/legal/privacy-policy' })
              }}
            >
              {t('privacyPolicies')}
            </TopicElement>
            <TopicElement>{t('securityMeasures')}</TopicElement>
          </TopicContainer>
          <TopicContainer>
            <TopicHeader>
              {t('disputeResolutionAndLegalAssistance')}
            </TopicHeader>
            <TopicElement>{t('handlingDisputesWithStudents')}</TopicElement>
            <TopicElement>{t('escalationProcedures')}</TopicElement>
            <TopicElement>{t('legalSupportResources')}</TopicElement>
            <TopicElement>{t('disputeResolutionFaq')}</TopicElement>
          </TopicContainer>
        </TopicsContainer>
      )}
    </div>
  )
}

export default Topics
